export const EXTERNAL_ROUTES = {
  SIGN_IN: "https://app.intercom.com/admins/sign_in",
  STANDALONE_START_FREE_TRIAL: "https://fin.ai/signup",
  REACT_SUITE_START_FREE_TRIAL:
    "https://www.intercom.com/signup?solution_id=29",
  REACT_GENERIC_START_FREE_TRIAL: "https://www.intercom.com/signup",
  REACT_ESSENTIAL_START_FREE_TRIAL:
    "https://www.intercom.com/signup?solution_id=28",
  REACT_EXPERT_START_FREE_TRIAL:
    "https://www.intercom.com/signup?solution_id=30",
  // fin_agent_type is what signup gates the Fin for Sales experience on.
  // fin-ai's twin also carries cta_domain=fin; this one must not — that param
  // is pure attribution, and signup defaults it to "intercom" when absent.
  REACT_SALES_AGENT_START_FREE_TRIAL:
    "https://www.intercom.com/signup?fin_agent_type=sales",
  // React signup migrations of the Startup Partner (27) and Early Stage (26)
  // program signups. The React app forwards solution_id to account creation and
  // routes /signup to /signup/email itself, so no explicit /email entry needed.
  REACT_STARTUP_START_FREE_TRIAL:
    "https://www.intercom.com/signup?solution_id=27",
  REACT_STARTUPS_APPLY: "https://www.intercom.com/signup?solution_id=26",
  EARLY_STAGE_SIGNUP: "https://www.intercom.com/signup/email?solution_id=26",
  FIN: "https://fin.ai",
  FIN_ROI_CALCULATOR: "https://fin.ai/roi-calculator",
  FIN_VOICE: "https://fin.ai/voice",
};

export const EXTERNAL_ROUTES_THAT_SHOULD_INCLUDE_UTM_PARAMS = [
  EXTERNAL_ROUTES.STANDALONE_START_FREE_TRIAL,
  EXTERNAL_ROUTES.REACT_SUITE_START_FREE_TRIAL,
  EXTERNAL_ROUTES.REACT_GENERIC_START_FREE_TRIAL,
  EXTERNAL_ROUTES.REACT_ESSENTIAL_START_FREE_TRIAL,
  EXTERNAL_ROUTES.REACT_EXPERT_START_FREE_TRIAL,
  EXTERNAL_ROUTES.REACT_SALES_AGENT_START_FREE_TRIAL,
  EXTERNAL_ROUTES.REACT_STARTUP_START_FREE_TRIAL,
  EXTERNAL_ROUTES.REACT_STARTUPS_APPLY,
  EXTERNAL_ROUTES.EARLY_STAGE_SIGNUP,
];
